import { useData } from '@app/data/repositories';
import { CalendarScreen } from './CalendarScreen';
import { useCalendar } from './useCalendar';

/** Вход календаря: данные и навигация здесь, сам экран о них не знает. */
export function CalendarRoute({
  onOpenEvent,
  onOpenClient,
  creating,
  onCreatingChange,
}: {
  onOpenEvent: (id: string) => void;
  onOpenClient: (id: string) => void;
  creating: boolean;
  onCreatingChange: (creating: boolean) => void;
}) {
  const { db } = useData();
  const { state, actions } = useCalendar(db);

  return (
    <CalendarScreen
      state={state}
      actions={actions}
      onOpenEvent={onOpenEvent}
      onOpenClient={onOpenClient}
      creating={creating}
      onCreatingChange={onCreatingChange}
    />
  );
}
